import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams, Link } from "react-router-dom";
import "./css/Review.css";
import { useDispatch, useSelector } from "react-redux";
import { getCall, postCall } from "./../utils/Network";
import { removeItemFromCart } from "../slices/signUp";
import { useTranslation } from "react-i18next";
import AddCardForm from "./addCardForm";
import countries from "../utils/countries_states.json";
import scrollToTop from "../components/hooks/ScrollToTop";
import { FaCreditCard } from "react-icons/fa";
import { BsCashCoin } from "react-icons/bs";
import * as Yup from "yup";
import Select from "react-select";
import { MdCurrencyBitcoin } from "react-icons/md";
import { BsFillCreditCard2BackFill } from "react-icons/bs";
import Modal from "../components/Modal";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Month, Day, Year } from "../components/Select";
import { IconAward, IconWallet } from "@tabler/icons-react";
import {
  addUserData,
  addAssociationData,
  setToken,
  setAssociateId,
} from "../slices/signUp";

import { FaEdit } from "react-icons/fa";
import { toast } from "react-toastify";
import { MdDelete } from "react-icons/md";
import LanguageDropdown from "../components/LanguageDropdown";
import { hideLoader, showLoader } from "../slices/loader";
import Loader from "../components/Loader";
import { flagEnabled } from "../utils/flag";
import ProgressBar from "../components/ProgressBar";
import { LuWallet } from "react-icons/lu";
import { MdOutlineCurrencyBitcoin } from "react-icons/md";

const ApiKey = process.env.REACT_APP_API_KEY;

function useQuery() {
  return new URLSearchParams(useLocation().search);
}
// Review component

export default function Review() {
  let params = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [userData, setUserData] = useState({});
  const [isCart, setIsCard] = useState(false);
  const dispatch = useDispatch();
  // const isLoading = useSelector((state) => state.loader.isLoading);
  const storeId = location.state?.storeId || "4";
  const [regionId, setRegionId] = useState(null);
  const cart = useSelector((state) => state.signup.cart);
  const [merchantData, setMerchantData] = useState([]);
  const [merchantId, setMerchantId] = useState();
  const [couponCode, setCouponCode] = useState("");
  const [appliedCoupon, setAppliedCoupon] = useState("");
  const [isApplied, setIsApplied] = useState(false);
  const [totalPrice, setTotalPrice] = useState(0);
  const [calculateData, setCalculateData] = useState({});
  const [collectToken, setCollectToken] = useState("");
  const [errorMsg, setErrorMsg] = useState();
  const query = useQuery();
  const associateEmail = query.get("email");

  const [isCardForm, setIsCardForm] = useState(false);
  // const token = useSelector((state) => state.signup.token);
  const tokenFromRedux = useSelector((state) => state.signup.token);
  const associateIdFromRedux = useSelector((state) => state.signup.associateId);

  const token = tokenFromRedux || sessionStorage.getItem("token");
  const associateId =
    associateIdFromRedux || localStorage.getItem("associateId");

  //   useEffect(() => {
  //   if (associateIdFromQuery) {
  //     const decodedId = atob(associateIdFromQuery);
  //     localStorage.setItem('associateId', decodedId);
  //     sessionStorage.setItem('associateId', decodedId);
  //     dispatch(setAssociateId(decodedId));
  //   }
  // }, [associateIdFromQuery]);

  const associationResponse = associateId;

  const myHeaders = { "API-key": ApiKey };
  const bearerHeaders = { Authorization: "Bearer " + token };
  const [cardInfo, setCardInfo] = useState([]);
  const [selectedCard, setSelectedCard] = useState(null);
  const [showCardInfo, setShowCardInfo] = useState(false);
  const [couponMsg, setCouponMsg] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [creditModal, setCreditPop] = useState(false);
  const [restrictedProductNames, setRestrictedProductNames] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [isRecurringChecked, setIsRecurringChecked] = useState(false);
  const [isAgreeChecked, setIsAgreeChecked] = useState(false);

  const [openModal, setOpenModal] = useState(false);
  const [ageError, setAgeError] = useState("");
  const [showPasswordPopup, setShowPasswordPopup] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const [passwordValidations, setPasswordValidations] = useState({
    minLength: false,
    maxLength: false,
    hasUppercase: false,
    hasLowercase: false,
    hasNumber: false,
    hasSpecialChar: false,
  });

  const [selectedPhoneCode, setSelectedPhoneCode] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const getEnrollerId = JSON.parse(sessionStorage.getItem("enroller"));

  useEffect(() => {
    scrollToTop();
  }, []);

  useEffect(() => {
    fetchAssociateData();
  }, []);

  useEffect(() => {
    if (userData.associateId) {
      calculateTotalPrice();
    }
    if (userData && countries?.data?.length) {
      let tempcountry = countries?.data?.find((country) => {
        return country?.iso2 === userData?.billingAddress?.countryCode;
      });
      setSelectedOption(tempcountry);
      setSelectedState(
        tempcountry?.states?.find((state) => {
          return state?.value === userData?.billingAddress?.state;
        }) || null,
      );
    }
  }, [userData, cart]);

  useEffect(() => {
    const html = document.getElementsByTagName("html")[0];
    html.setAttribute("data-wf-page", "68603f7a056ff6f78f58cb16");
    html.setAttribute("data-wf-site", "68603f7a056ff6f78f58cab1");
    window.Webflow && window.Webflow.destroy();
    window.Webflow && window.Webflow.ready();
    window.Webflow && window.Webflow.require("ix2").init();
    document.dispatchEvent(new Event("readystatechange"));
  }, []);

  const customStyles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: "rgba(255, 255, 255, 0.11)",
      color: "white",
      borderColor: state.isFocused ? "#888" : "#555",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#888",
      },
    }),
    singleValue: (base) => ({
      ...base,
      color: "white",
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: "#383a41",
    }),
    option: (base, { isDisabled, isFocused, isSelected }) => ({
      ...base,
      backgroundColor: isFocused ? "gray" : "#383a41",
      color: "white",
      cursor: isDisabled ? "not-allowed" : "pointer",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#aaa",
    }),
  };

  const countryOptions = countries?.data
    .filter((item) => item.states?.length > 0)
    .map((item) => {
      return item;
    });
  // Function to handle option selection
  const handleOptionChange = (selectedOption) => {
    // console.log(selectedOption, "countryy");

    setSelectedOption(selectedOption);

    if (selectedOption?.phoneCode) {
      setSelectedPhoneCode({
        value: selectedOption.phoneCode,
        label: selectedOption.phoneCode,
        iso2: selectedOption.iso2,
      });
    }
    setSelectedState(null);
  };

  // Handle Create Associate Function
  const handleUpdateAssociate = async (submittedFormValues) => {
    setIsLoading(true);
    const {
      firstname,
      lastname,
      line1,
      line2,
      city,
      zip,
      country,
      state,
      month,
      year,
      day,
    } = submittedFormValues;

    let birthDate = `${year}-${month}-${day}`;
    if (day < 10) {
      birthDate = `${year}-${month}-0${day}`;
    }

    const bodyData = {
      associateId: userData?.associateId,
      firstName: firstname,
      lastName: lastname,
      legalFirstName: firstname,
      legalLastName: lastname,
      phone: userData?.phone,
      birthDate: birthDate,
      externalId: userData.externalId || "",
      taxId: userData.taxId || "",
      taxResaleNumber: userData.taxResaleNumber || "",
      backOfficeId: userData.backOfficeId || "",
      languageCode: userData?.languageCode ?? "en",
      termsIP: userData.termsIP || "",
      acceptedTerms: userData.acceptedTerms,
      pillarsId: userData.pillarsId || "",
      enrollerId: userData?.enrollerId,
      singUpDate: userData?.singUpDate,
      phoneCode: getEnrollerId?.phoneCode,
      userType: userData.userType,
      associateStatus: userData.associateStatus,
      shippingAddress: [
        {
          line1: line1,
          line2: line2,
          state: state,
          city: city,
          zip: zip,
          countryCode: country,
        },
      ],
      billingAddress: {
        line1: line1,
        line2: line2,
        state: state,
        city: city,
        zip: zip,
        countryCode: country,
      },
      webAlias: [
        {
          enabled: true,
          alias: userData?.webAlias?.[0]?.alias,
        },
      ],
      associateKYC: userData?.associateKYC,
    };
    // console.log("Sending payload:", bodyData);

    return await postCall({
      url: "updateAssociate",
      // "https://wapp-obelisk-api-stg-wus2.azurewebsites.net/api/v1/Associate/UpdateAssociate",
      bodyData,
      header: bearerHeaders,
    }).then(async (response) => {
      if (response?.status == 200) {
        dispatch(addAssociationData(response?.data));
        dispatch(setAssociateId(response?.data?.associateId));
        localStorage.setItem("associateid", response.data.associateId);
        setUserData({ ...userData, ...bodyData });
        setOpenModal(false);
        setIsLoading(false);
        fetchAssociateData();
      } else {
        setOpenModal(false);
        setIsLoading(false);
      }
    });
  };

  const formatOptionLabel = ({ label, iso2 }) => (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <img
        src={`https://flagcdn.com/48x36/${iso2?.toLowerCase()}.png`}
        alt={label}
        style={{
          width: "26px",
          height: "26px",
          borderRadius: "50%",
          objectFit: "cover",
        }}
      />
      <span style={{ color: "white" }}>{label}</span>
    </div>
  );

  // Calculate total price of products in cart
  const calculateTotalPrice = async (couponCode) => {
    if (!cart || Object.keys(cart).length === 0) {
      setCalculateData(null);
      setTotalPrice(0);
      setIsApplied(false);
      setCouponMsg("");
      return;
    }
    setIsLoading(true);
    console.log(process.env.REACT_APP_FLAG_REVIEW_ENHANCE_COUPON);

    let shipping =
      userData && userData.shippingAddress && userData.shippingAddress[0];
    const bodyData = {
      currencyCode: "usd",
      shipMethodId: 1,
      storeId: storeId,
      shippingAddress: {
        line1: shipping && shipping.line1,
        line2: shipping && shipping.line2,
        state: shipping && shipping.state,
        city: shipping && shipping.city,
        zip: shipping && shipping.zip,
        countryCode: shipping && shipping.countryCode,
      },
      associateId: userData?.associateId || 0,
      orderTypeId: 1,
      associateType: 1,
      orderDetails:
        Object.keys(cart).length &&
        Object.keys(cart).map((key) => ({
          itemId: cart[key].id,
          quantity: cart[key].quantity,
        })),
      orderCoupons: [
        {
          couponCode: couponCode ? couponCode : "coupon!",
        },
      ],
    };

    try {
      const myHeaders = { Authorization: "Bearer " + token };
      const response = await postCall({
        url: "calculatePrice",
        bodyData,
        header: myHeaders,
      });
      if (response?.data) {
        setCalculateData(response?.data);

        setTotalPrice(response?.data?.total);

        if (couponCode) {
          if (response.data.couponInfo && response.data.couponInfo.length > 0) {
            setIsApplied(true);
            setCouponMsg("");
            toast.success(t("couponAppliedSuccessfully"));
          } else {
            setIsApplied(false);

            // const errorText = t("");
            // setCouponMsg(errorText);
            toast.error(t("invalidOrExpiredCoupon"));
            // setCouponMsg("");
            // setIsApplied(false);
          }
        }
      }
      setIsLoading(false);
    } catch (error) {
      console.log("Error calculating total price:", error);
      toast.error("Failed to calculate price. Please try again.");
      setIsLoading(false);
    }
  };

  useEffect(() => {
    async function getMerchant() {
      const response = await postCall({
        url: "getAvailableMerchant",
        bodyData: { regionId: regionId, storeId: storeId },
        header: bearerHeaders,
      });

      if (response?.data) {
        setMerchantData(response?.data);
      }
    }
    if (regionId) {
      getMerchant();
    }
  }, [regionId]);

  const fnMerchant = (merchantId) => {
    const restrictedIds = [4, 5, 6];
    const cartItems = Object.values(cart);
    const restrictedProducts = cartItems?.filter((item) =>
      restrictedIds.includes(Number(item.id)),
    );

    if (restrictedProducts.length > 0 && merchantId === 3) {
      // Create product names string
      const productNames = restrictedProducts.map((p) => p.name).join(", ");
      setRestrictedProductNames(productNames);
      setCreditPop(true);

      // // Show toast
      // toast.error(
      //   `This payment method is unavailable for: ${productNames}. Please choose another method.`,
      //   { autoClose: 5000 }
      // );

      // Optionally: stop showing card info for restricted merchant
      setShowCardInfo(false);
      return;
    }

    setMerchantId(merchantId);
    if (merchantId === 3) {
      getPayment();
      setShowCardInfo((prevShowCardInfo) => !prevShowCardInfo);
      // Show card info only for Credit Card option
    } else {
      setShowCardInfo(false);
    }
  };

  const fetchAssociateData = async () => {
    setIsLoading(true);
    const id = associationResponse;
    const response = await getCall({
      url: "getAssociate",
      urlParams: { associateid: id },
      header: myHeaders,
    });
    if (response?.data) {
      setUserData(response?.data);

      let countrycode = response.data?.billingAddress?.countryCode || "";

      let reg = await getCall({
        url: "getRegion",
        urlParams: { countryCode: countrycode, stateCode: "all" },
        header: { Authorization: "Bearer " + token },
      });

      if (reg.data && reg.data.regionId) {
        setRegionId(reg.data.regionId);
      } else {
        setRegionId(2);
      }
    }
    setIsLoading(false);
  };

  function Row({ left, right }) {
    return (
      <div className="row">
        <div className="left-row">
          <strong className="left-row-strong">{left}</strong>
        </div>
        <div className="right-row">
          <span className="right-row-span">{right}</span>
        </div>
      </div>
    );
  }

  const removeFromCart = (productToRemove) => {
    dispatch(removeItemFromCart(productToRemove));
  };

  const applyCoupon = () => {
    if (couponCode.trim() === "") {
      setCouponMsg(t("pleaseEnterTheCouponCode"));
      return;
    }
    // if (flagEnabled('REVIEW_ENHANCE_COUPON')) { setIsApplied(true); }
    setCouponMsg("");
    setAppliedCoupon(couponCode.trim());
    calculateTotalPrice(couponCode.trim());
  };

  const fnCardPay = (token, totalPrice) => {
    const options = {
      method: "POST",
      headers: {
        accept: "application/x-www-form-urlencoded",
        "content-type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        type: "sale",
        payment_token: token,

        amount: totalPrice,

        security_key: "6457Thfj624V5r7WUwc5v6a68Zsd6YEm",
      }),
    };

    fetch("https://merchantx.transactiongateway.com/api/transact.php", options)
      .then((response) => {
        return response;
      })
      .then((response) => {
        if (response.status == 200) {
          fnCreateOrder();
        }
      })
      .catch((err) => console.error(err));
  };

  const fnPayment = async () => {
    await fnCreateOrder();
  };

  const isCouponBlockingPayment = () => {
    return couponCode.trim() !== "" && !isApplied;
  };

  const handleProcessPayment = async () => {
    if (isCouponBlockingPayment()) {
      const msg = t("pleaseApplyCouponFirst");
      toast.warning(msg);
      setCouponMsg(msg);
      return;
    }
    if (!isRecurringChecked) {
      const translateCheckMsg = t(
        "pleaseClickCheckboxAgreeRecurringSubscription",
      );
      setErrorMsg(translateCheckMsg);
      toast.warning(translateCheckMsg);
      return;
    }

    if (!merchantId) {
      const translatePaymentMsg = t("pleaseSelectPaymentMethod");
      toast.warning(translatePaymentMsg);
      setErrorMsg(translatePaymentMsg);
      return;
    }

    setErrorMsg("");
    setCouponMsg("");
    setIsLoading(true);

    try {
      await fnPayment();
    } catch (error) {
      console.error("Payment failed:", error);
      toast.error(t("paymentFailedTryAgain"));
    } finally {
      setIsLoading(false);
    }
  };

  function calculateAge(birthDateString) {
    const birthDate = new Date(birthDateString);

    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();

    const monthDifference = today.getMonth() - birthDate.getMonth();

    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  }

  const getPayment = async () => {
    const getData = {
      url: "getPayment",
      urlParams: {
        associateid: associationResponse,
      },
      header: bearerHeaders,
    };
    const resp = await getCall(getData);
    if (resp.data) {
      const sortedData = resp.data.sort(
        (a, b) => b.priorityLevel - a.priorityLevel,
      );
      let cardArray = sortedData.map((item) => ({
        displayInfo: `xxxxxxxxxxx${item.displayInfo}`.replace(/(.{4})/g, "$1 "),
        externalId: item.externalId, // Store the savedPaymentMethodId along with displayInfo
      }));
      setCardInfo(cardArray);
    }

    fnCardForm(false);
  };

  const fnCreateOrder = async () => {
    let shipping = userData.shippingAddress[0];

    let bodyData = {
      currencyCode: "usd",
      shipMethodId: 1,
      storeId: 4,
      shippingAddress: {
        line1: shipping.line1,
        line2: shipping.line2,
        state: shipping.state,
        city: shipping.city,
        zip: shipping.zip,
        countryCode: shipping.countryCode,
      },
      associateId: userData.associateId,
      orderTypeId: 1,
      shipToName: userData.firstName,
      emailAddress: userData.email,
      phone: userData.phone,
      associateType: 1,
      orderDetails:
        Object.keys(cart).length &&
        Object.keys(cart).map((item) => ({
          itemId: cart[item].id,
          quantity: cart[item].quantity,
        })),
      orderCoupons: [
        {
          couponCode: appliedCoupon || "",
        },
      ],
      paymentInfo: [
        {
          merchantId: merchantId,
          currencyCode: "usd",
          savePayment: true,
          fraudPreventionId: "123",
          ipAddress: "1.2.3",
          amount: totalPrice,
          savedPaymentMethodId: merchantId === 3 ? selectedCard : "string",
        },
      ],
    };
    dispatch(showLoader());
    try {
      let order = await postCall({
        url: "createOrder",
        bodyData,
        header: bearerHeaders,
      });
      if (order?.data?.success) {
        console.log(merchantId, "id");

        if (
          merchantId === 2 &&
          order?.data?.success &&
          order.data.paymentInfo?.[0]?.message
        ) {
          const paymentUrl = order?.data?.paymentInfo?.[0]?.message;
          console.log(paymentUrl, order, "details");
          sessionStorage.removeItem("itemIdFromQuery");
          window.location.href = paymentUrl;
        } else {
          // clearCart();
          // Determine if user is affiliate based on cart items
          const isAffiliate = Object.values(cart).some((item) => {
            console.log(item, "item");
            const name = (item.name || "").toLowerCase();
            const categories = item.categories || [];
            const hasAffiliateCategory = categories.some((cat) =>
              (cat.name || "").toLowerCase().includes("affiliate"),
            );
            // associate type should be 2 for affiliate
            return (
              name.includes("affiliate") ||
              name.includes("enrollment") ||
              hasAffiliateCategory
            );
          });
          const userType = isAffiliate ? "affiliate" : "customer";
          // Store webAlias for the referral link on the confirmation page
          const alias = userData?.webAlias?.[0]?.alias;
          if (alias) {
            sessionStorage.setItem("referralWebAlias", alias);
          }
          sessionStorage.removeItem("itemIdFromQuery");
          return navigate(`/order-confirmation/${userType}/${order.data.id}`);
        }
      } else {
        let errRes = order?.data?.message || "204";
        let errArr = errRes.split("-");
        let errCode = errArr[errArr.length - 1].trim();

        if (isNaN(errCode)) {
          errCode = "204";
        }

        let errmsg = "nmiError" + errCode;

        const translatedMsg = t(errmsg);

        setErrorMsg(translatedMsg);
        toast.error(translatedMsg);
      }
    } catch (error) {
      console.log("error:", error);
      toast.error(t("Something went wrong"));
    } finally {
      dispatch(hideLoader());
    }
  };

  const fnBack = () => {
    navigate(
      `/${params.enrollerCode}/enrollment-kit?associateId=${associationResponse}`,
    );
  };

  const formatDate = (dateTime) => {
    if (!dateTime) {
      return dateTime;
    }
    return `${dateTime.substr(5, 2)}/${dateTime.substr(8, 2)}/${dateTime.substr(
      0,
      4,
    )}`;
  };
  const fnCardForm = (value) => {
    setIsCardForm(value);
  };

  //Every thing is good only when i click update they call at same time coupon Api With UpdateAsspciate
  const checkKeyPress = (e, action, submitForm) => {
    if (e.key !== "Enter") return;

    e.preventDefault();
    e.stopPropagation();

    if (action === "applyCoupon") {
      applyCoupon();
    } else if (action === "update" && typeof submitForm === "function") {
      submitForm();
    } else if (action === "payment") {
      handleProcessPayment();
    }
  };

  const formatedDate = formatDate(userData?.birthDate);
  const day =
    parseInt(formatedDate?.split("/")[1]) <= 9
      ? formatedDate?.split("/")[1].replace("0", "")
      : formatedDate?.split("/")[1];
  return (
    <>
      {isLoading && <Loader />}
      <Modal
        isOpen={openModal}
        onClose={() => setOpenModal(false)}
        title={t("editUserInfo")}
        Modal={true}
      >
        <Formik
          initialValues={{
            email: userData?.email ?? "",
            firstname: userData?.firstName ?? "",
            lastname: userData?.lastName ?? "",
            line1: userData?.billingAddress?.line1 ?? "",
            line2: userData?.billingAddress?.line2 ?? "",
            city: userData?.billingAddress?.city ?? "",
            zip: userData?.billingAddress?.zip ?? "",
            phone: "",
            country: selectedOption?.iso2 ?? "",
            state: selectedState?.value ?? "",
            agreeTerms: false,
            month: formatedDate?.split("/")[0] || "",
            day: day,
            year: formatedDate?.split("/")[2] || "",
            webalias: "",
          }}
          validationSchema={Yup.object({
            firstname: Yup.string().required(t("firstNameIsRequired")),
            lastname: Yup.string().required(t("lastNameIsRequired")),
            month: Yup.string().required(t("monthIsRequired")),
            day: Yup.string().required(t("dayIsRequired")),
            year: Yup.string().required(t("yearIsRequired")),
            country: Yup.string().required(t("countryIsRequired")),
            state: Yup.string().required(t("stateIsRequired")),
            city: Yup.string().required(t("cityIsRequired")),
            zip: Yup.string().required(t("zipCodeIsRequired")),
            line1: Yup.string().required(t("addressIsRequired")),
            line2: Yup.string(),
          })}
          onSubmit={async (values, { isSubmitting, setSubmitting }) => {
            let birthDate = `${values.year}-${values.month}-${values.day}`;
            let age = calculateAge(birthDate);

            setAgeError("");
            dispatch(addUserData({ data: values }));
            await handleUpdateAssociate(values);
            setSubmitting(false);
          }}
        >
          {({
            isSubmitting,
            values,
            handleBlur,
            setFieldError,
            validateForm,
            setTouched,
            submitForm,
          }) => (
            <Form>
              <div className="width_50">
                <label className="input-title">{t("firstName")}</label>
                <Field
                  name="firstname"
                  className="theme-inp"
                  maxLength={40}
                  placeholder={t("firstName")}
                  onKeyDown={(e) => {
                    checkKeyPress(e, "update", submitForm);
                  }}
                />
                <ErrorMessage
                  name="firstname"
                  component="small"
                  className="block align-left error-message"
                />
              </div>

              <div className="width_50">
                <label className="input-title">{t("lastName")}</label>
                <Field
                  name="lastname"
                  className="theme-inp"
                  maxLength={40}
                  placeholder={t("lastName")}
                  onKeyDown={(e) => {
                    checkKeyPress(e, "update", submitForm);
                  }}
                />
                <ErrorMessage
                  name="lastname"
                  component="small"
                  className="block align-left error-message"
                />
              </div>

              <div>
                <label className="input-title">{t("dateOfBirth")}</label>
                <div className="grid-date">
                  <div className="date-field">
                    <Field
                      className="theme-inp"
                      component={Month}
                      year={values.year}
                      day={values.day}
                      name="month"
                      cn="month"
                      styles={customStyles}
                      onKeyDown={(e) => {
                        checkKeyPress(e, "update", submitForm);
                      }}
                    />
                    <ErrorMessage
                      name="month"
                      component="small"
                      className="block align-left error-message"
                    />
                  </div>
                  <div className="date-field">
                    <Field
                      component={Day}
                      name="day"
                      cn="day"
                      month={values.month}
                      year={values.year}
                      styles={customStyles}
                      onKeyDown={(e) => {
                        checkKeyPress(e, "update", submitForm);
                      }}
                    />
                    <ErrorMessage
                      name="day"
                      component="small"
                      className="block align-left error-message"
                    />
                  </div>
                  <div className="date-field">
                    <Field
                      component={Year}
                      month={values.month}
                      day={values.day}
                      name="year"
                      cn="year"
                      styles={customStyles}
                      onKeyDown={(e) => {
                        checkKeyPress(e, "update", submitForm);
                      }}
                    />
                    <ErrorMessage
                      name="year"
                      component="small"
                      className="block align-left error-message"
                    />
                  </div>
                </div>
                <small className="block align-left error-message">
                  {ageError}
                </small>
              </div>

              <div className="col-xs-12 col-md-12 pb-15">
                <label className="white pb-1">{t("selectACountry")}</label>
                <Field name="country">
                  {({ field, form }) => (
                    <>
                      <Select
                        className="country-box"
                        {...field}
                        value={selectedOption}
                        onChange={(selectedOption) => {
                          handleOptionChange(selectedOption);
                          form.setFieldValue(field.name, selectedOption?.iso2);
                          form.setFieldValue("state", "");
                        }}
                        options={countryOptions}
                        placeholder={t("selectACountry")}
                        onKeyDown={(e) => {
                          checkKeyPress(e, "update", submitForm);
                        }}
                        styles={customStyles}
                        formatOptionLabel={formatOptionLabel}
                      />
                      {form.errors.country && form.touched.country && (
                        <small className="block align-left error-message">
                          {form.errors.country}
                        </small>
                      )}
                    </>
                  )}
                </Field>
              </div>

              <div className="col-xs-12 col-md-12  pb-15">
                <label className="white pb-1">{t("selectAState")}</label>
                <Field name="state">
                  {({ field, form }) => (
                    <>
                      <Select
                        className="state-box"
                        {...field}
                        value={selectedState}
                        onChange={(selectedState) => {
                          form.setFieldValue(
                            field.name,
                            selectedState.value || "",
                          );
                          setSelectedState(selectedState);
                        }}
                        options={selectedOption?.states || []}
                        placeholder={t("selectAState")}
                        styles={customStyles}
                        onKeyDown={(e) => {
                          checkKeyPress(e, "update", submitForm);
                        }}
                      />
                      {form.errors.state && form.touched.state && (
                        <small className="block align-left error-message">
                          {form.errors.state}
                        </small>
                      )}
                    </>
                  )}
                </Field>
              </div>

              <div className="col-xs-12 col-md-12  pb-15">
                <label className="white pb-1">{t("city")}</label>
                <Field
                  name="city"
                  className="theme-inp"
                  maxLength={50}
                  placeholder={t("city")}
                  onKeyDown={(e) => {
                    checkKeyPress(e, "update", submitForm);
                  }}
                />
                <ErrorMessage
                  name="city"
                  component="small"
                  className="block align-left error-message"
                />
              </div>

              <div className="col-xs-12 col-md-12  pb-15">
                <label className="white pb-1">{t("zip")}</label>
                <Field
                  name="zip"
                  className="theme-inp"
                  maxLength={40}
                  placeholder={t("zip")}
                  onKeyDown={(e) => {
                    checkKeyPress(e, "update", submitForm);
                  }}
                />
                <ErrorMessage
                  name="zip"
                  component="small"
                  className="block align-left error-message"
                />
              </div>

              <div className="address-field">
                <div className="col-xs-12 col-md-12  pb-15">
                  <label className="white pb-1">{t("addressLine1")}</label>
                  <Field
                    name="line1"
                    className="theme-inp"
                    placeholder={t("addressLine1")}
                    onKeyDown={(e) => {
                      checkKeyPress(e, "update", submitForm);
                    }}
                  />
                  <ErrorMessage
                    name="line1"
                    component="small"
                    className="block align-left error-message"
                  />
                </div>

                <div className="col-xs-12 col-md-12  pb-15">
                  <label className="white pb-1">{t("addressLine2")}</label>
                  <Field
                    name="line2"
                    className="theme-inp"
                    placeholder={t("addressLine2")}
                    onKeyDown={(e) => {
                      checkKeyPress(e, "update", submitForm);
                    }}
                  />
                  <ErrorMessage
                    name="line2"
                    component="small"
                    className="block align-left error-message"
                  />
                </div>
              </div>

              <div className="primary-button-wrapper">
                <a
                  href="#"
                  type="button"
                  className="inner-button w-inline-block"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    submitForm();
                  }}
                >
                  <div className="primary-button-border-wrap">
                    <div className="inner-button-wrap">
                      <div className="inner-button-text-wrap">
                        <div className="inner-button-text">{t("update")}</div>
                        <div className="inner-button-hover-text">
                          {t("update")}
                        </div>
                      </div>
                      <div className="inner-button-hover-bg"></div>
                    </div>
                  </div>
                  <div className="line-wrap-inner">
                    <div className="inner-line-wrap _1">
                      <div className="line"></div>
                      <div className="line _2"></div>
                    </div>
                    <div className="inner-line-wrap _2">
                      <div className="line _3"></div>
                      <div className="line _4"></div>
                    </div>
                    <div className="inner-line-wrap _3">
                      <div className="line _5"></div>
                      <div className="line _6"></div>
                    </div>
                    <div className="inner-line-wrap _4">
                      <div className="line _7"></div>
                      <div className="line _8"></div>
                    </div>
                  </div>
                </a>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
      <Modal
        isOpen={creditModal}
        onClose={() => setCreditPop(false)}
        // title={}
        Modal={true}
      >
        <div className="modal-header">
          <div className="modal-title">{t("paymentMethodUnavailable")}</div>
        </div>
        <div className="modal-body">
          <p>
            {t("thisPaymentMethodIsUnavailable", {
              productNames: restrictedProductNames,
            })}
          </p>
        </div>
        <div className="primary-button-wrapper modal-footer">
          <a
            href="#"
            className="inner-button w-inline-block"
            onClick={(e) => {
              setCreditPop(false);
            }}
          >
            <div className="primary-button-border-wrap">
              <div className="inner-button-wrap">
                <div className="inner-button-text-wrap">
                  <div className="inner-button-text">{t("ok")}</div>
                  <div className="inner-button-hover-text">{t("ok")}</div>
                </div>
                <div className="inner-button-hover-bg"></div>
              </div>
            </div>
            <div className="line-wrap-inner">
              <div className="inner-line-wrap _1">
                <div className="line"></div>
                <div className="line _2"></div>
              </div>
              <div className="inner-line-wrap _2">
                <div className="line _3"></div>
                <div className="line _4"></div>
              </div>
              <div className="inner-line-wrap _3">
                <div className="line _5"></div>
                <div className="line _6"></div>
              </div>
              <div className="inner-line-wrap _4">
                <div className="line _7"></div>
                <div className="line _8"></div>
              </div>
            </div>
          </a>
        </div>
      </Modal>
      <div className="theme-bg">
        <div className="enrollment-navbar">
          <div className="noa-logo heading-margin"></div>
          <LanguageDropdown />
        </div>
        <div className="enrollment-kit-page">
          <div className="center"></div>
          <ProgressBar currentStep={"4"} />
          <div className="review">
            <div className="heading">
              <h2 className="title">{t("review")}</h2>
            </div>
            <div className="reviewCard">
              <div className="left-reviewCard">
                <div className="upper-reviewCard relative">
                  {/* <div style={{ textAlign: "right" }}>
                    <button
                      onKeyDown={(e) => {
                        checkKeyPress();
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setOpenModal(true);
                      }}
                      className="btn-edit-review"
                    >
                      <FaEdit />
                    </button>
                  </div> */}
                  <div className="user-info-div">
                    <p>{t("personalInformation")}</p>
                    <div className="navbar-button-wrapper-edit">
                      <div className="primary-button-wrapper">
                        <a
                          href="#"
                          className="inner-button w-inline-block"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setOpenModal(true);
                          }}
                        >
                          <div className="primary-button-border-wrap">
                            <div className="inner-button-wrap">
                              <div className="inner-button-text-wrap">
                                <div className="inner-button-text">
                                  {t("edit")}
                                </div>
                                <div className="inner-button-hover-text">
                                  {t("edit")}
                                </div>
                              </div>
                              <div className="inner-button-hover-bg"></div>
                            </div>
                          </div>
                          <div className="line-wrap-inner">
                            <div className="inner-line-wrap _1">
                              <div className="line"></div>
                              <div className="line _2"></div>
                            </div>
                            <div className="inner-line-wrap _2">
                              <div className="line _3"></div>
                              <div className="line _4"></div>
                            </div>
                            <div className="inner-line-wrap _3">
                              <div className="line _5"></div>
                              <div className="line _6"></div>
                            </div>
                            <div className="inner-line-wrap _4">
                              <div className="line _7"></div>
                              <div className="line _8"></div>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <Row left={t("email")} right={userData?.email} />
                  <Row left={t("firstName")} right={userData?.firstName} />
                  <Row left={t("lastName")} right={userData?.lastName} />
                  <Row
                    left={t("referralCode")}
                    right={userData?.webAlias?.[0]?.alias}
                  />
                  <Row left={t("dateOfBirth")} right={formatedDate} />
                  <Row
                    left={t("primaryAddress")}
                    right={`${userData?.billingAddress?.line1}, ${userData?.billingAddress?.line2}`}
                  />
                  <Row
                    left={t("city")}
                    right={userData?.billingAddress?.city}
                  />
                  <Row left={t("state")} right={selectedState?.label} />
                  <Row left={t("zip")} right={userData?.billingAddress?.zip} />
                  <Row left={t("country")} right={selectedOption?.label} />
                </div>

                <div className="payment-card">
                  <h3 className="payment-heading">{t("paymentMethods")}</h3>
                  <div className="row-paymt">
                    {merchantData &&
                      merchantData.map((item) => (
                        <div
                          key={item.merchantId}
                          className={`col-md-3 payment-opt ${merchantId === item.merchantId ? "selected" : ""
                            }`}
                          onClick={() => fnMerchant(item.merchantId)}
                          tabIndex={0}
                          onKeyDown={(e) => checkKeyPress(e, "payment", null)}
                        >
                          {/* Replace with your own images/icons for each payment method */}
                          {item.merchantId === 1 &&
                            item.displayName === "Cash" && (
                              <Link className="d-flex align-items-center">
                                <BsCashCoin className="white" />
                              </Link>
                            )}
                          {item.merchantId === 2 &&
                            item.displayName === "Cryptocurrency" && (
                              <Link className="d-flex align-items-center">
                                <MdCurrencyBitcoin className="white" />
                              </Link>
                            )}
                          {item.merchantId === 3 &&
                            item.displayName === "Credit Card" && (
                              <div className="payment-img">
                                <Link className="d-flex align-items-center">
                                  <FaCreditCard className="white" />
                                </Link>
                              </div>
                            )}
                          {item.merchantId === 4 &&
                            item.displayName === "Wallet" && (
                              <Link className="d-flex align-items-center">
                                <IconWallet stroke={2} className="white" />
                              </Link>
                            )}
                          {item.merchantId === 6 &&
                            item.displayName === "Rewards" && (
                              <Link className="d-flex align-items-center">
                                <IconAward stroke={2} className="white" />
                              </Link>
                            )}
                          {item.merchantId === 7 &&
                            item.displayName === "EWallet" && (
                              <Link className="d-flex align-items-center">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="white"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="icon icon-tabler icons-tabler-outline icon-tabler-wallet"
                                  aria-hidden="true"
                                  focusable="false"
                                >
                                  <path
                                    stroke="none"
                                    d="M0 0h24v24H0z"
                                    fill="none"
                                  />
                                  <path d="M17 8v-3a1 1 0 0 0 -1 -1h-10a2 2 0 0 0 0 4h12a1 1 0 0 1 1 1v3m0 4v3a1 1 0 0 1 -1 1h-12a2 2 0 0 1 -2 -2v-12" />
                                  <path d="M20 12v4h-4a2 2 0 0 1 0 -4h4" />
                                </svg>
                              </Link>
                            )}
                          {item.displayName === "Tygapay" && (
                            <Link className="d-flex align-items-center">
                              <FaCreditCard className="white" />
                            </Link>
                          )}
                          {item.displayName === "Credits" && (
                            <Link className="d-flex align-items-center">
                              <FaCreditCard className="white" />
                            </Link>
                          )}
                          <p>{item.displayName}</p>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              <div className="right-reviewCard">
                <div className="pricing-box">
                  <div className="pricing-name">
                    <b>{t("enrollmentKits")}</b>
                    <div className="primary-button-wrapper summary-explore-btn">
                      <a
                        href={`/${params?.enrollerCode}/enrollment-kit`}
                        className="inner-button w-inline-block"
                      >
                        <div className="primary-button-border-wrap">
                          <div className="inner-button-wrap">
                            <div className="inner-button-text-wrap">
                              <div className="inner-button-text">
                                {t("exploreMoreProducts")}
                              </div>
                              <div className="inner-button-hover-text">
                                {t("exploreMoreProducts")}
                              </div>
                            </div>
                            {/* <div className="inner-button-star-wrap">
                              <img
                                loading="lazy"
                                src="/images/inner-button-star-1.svg"
                                alt=""
                                className="inner-button-star _1"
                              />
                              <img
                                loading="lazy"
                                src="/images/inner-button-star-2.svg"
                                alt=""
                                className="inner-button-star _2"
                              />
                              <img
                                loading="lazy"
                                src="/images/inner-button-star-3.svg"
                                alt=""
                                className="inner-button-star _3"
                              />
                            </div> */}
                            <div className="inner-button-hover-bg"></div>
                          </div>
                        </div>
                        <div className="line-wrap-inner">
                          <div className="inner-line-wrap _1">
                            <div className="line"></div>
                            <div className="line _2"></div>
                          </div>
                          <div className="inner-line-wrap _2">
                            <div className="line _3"></div>
                            <div className="line _4"></div>
                          </div>
                          <div className="inner-line-wrap _3">
                            <div className="line _5"></div>
                            <div className="line _6"></div>
                          </div>
                          <div className="inner-line-wrap _4">
                            <div className="line _7"></div>
                            <div className="line _8"></div>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <ul>
                    {Object.keys(cart).length > 0 &&
                      Object.keys(cart).map((key, index) => (
                        <li key={index}>
                          <div className="pricing-footer">
                            <div className="pricing-footer-left">
                              {cart[key].name}
                            </div>
                            <div className="pricing-footer-right">
                              <label>{`$${(
                                cart[key].price * cart[key].quantity
                              )?.toFixed(2)}`}</label>
                              <button className="btn-trash">
                                <i
                                  className="fas fa-trash"
                                  onClick={() => {
                                    removeFromCart(cart[key]);
                                  }}
                                >
                                  <MdDelete />
                                </i>
                              </button>
                            </div>
                          </div>
                        </li>
                      ))}
                  </ul>
                  {/* <button className="theme-btn" style={{ marginTop: "10px", fontWeight: 'bold' }} onClick={() => navigate(`/${params.webalias}/enrollment-kit`)}>{t("exploreMoreProducts")}</button> */}
                </div>
                <div className="pricing-box">
                  <div className="pricing-name">
                    <b>{t("summary")}</b>
                  </div>
                  <div className="pricing-tax">
                    <div className="pricing-row">
                      <label className="left-label">{t("subTotal")} : </label>
                      <label className="right-label">
                        ${calculateData?.subTotal?.toFixed(2) ?? 0}
                      </label>
                    </div>
                    <div className="pricing-row">
                      <label className="left-label">{t("tax")} : </label>
                      <label className="right-label">
                        ${calculateData?.tax?.toFixed(2) ?? 0}
                      </label>
                    </div>
                    <div className="pricing-row">
                      <label className="left-label">{t("shipping")} : </label>
                      <label className="right-label">
                        ${calculateData?.shipping?.toFixed(2) ?? 0}
                      </label>
                    </div>
                    <div className="pricing-row">
                      <label className="left-label">{t("discount")} : </label>
                      <label className="right-label">
                        ${calculateData?.discountTotal?.toFixed(2) ?? 0}
                      </label>
                    </div>
                    <br />
                    <div className="pricing-row">
                      <label className="left-label">{t("total")} : </label>
                      <label className="right-label">
                        ${totalPrice?.toFixed(2) ?? 0}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="pricing-box">
                  <div className="pricing-name">
                    <b>{t("coupon")}</b>
                  </div>
                  <div className="form-group  ">
                    {flagEnabled("REVIEW_ENHANCE_COUPON") ? (
                      <input
                        placeholder={t("couponCode")}
                        value={isApplied ? appliedCoupon : couponCode}
                        disabled={isApplied}
                        onChange={(e) => setCouponCode(e.target.value)}
                        onKeyDown={(e) => checkKeyPress(e, "applyCoupon")}
                      />
                    ) : (
                      <input
                        placeholder={t("couponCode")}
                        value={couponCode}
                        onChange={(e) => setCouponCode(e.target.value)}
                        onKeyDown={(e) => checkKeyPress(e, "applyCoupon")}
                      />
                    )}
                    {/* <button className="btn-apply-coupon" onClick={applyCoupon}>
                      <label>{t('apply')}</label>
                    </button> */}
                    {flagEnabled("REVIEW_ENHANCE_COUPON") ? (
                      <>
                        <div className="btn-apply">
                          <div className="primary-button-wrapper">
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                if (isApplied) {
                                  toast.warning(t("alreadyApplied"));
                                  return;
                                }
                                applyCoupon();
                              }}
                              data-w-id="3af1c84f-ff74-c014-cb3b-40446b73b1f6"
                              className="primary-button w-inline-block"
                            >
                              <div className="primary-button-border-wrap">
                                <div className="primary-button-wrap">
                                  <div className="primary-button-text">
                                    {isApplied ? t("applied") : t("apply")}
                                  </div>
                                  <div className="primary-button-hover-text">
                                    {isApplied ? t("applied") : t("apply")}
                                  </div>
                                  <div className="primary-button-hover-bg"></div>
                                </div>
                              </div>
                              <div className="line-wrap">
                                <div className="primary-line-wrap _1">
                                  <div className="line _1"></div>
                                  <div className="line _2"></div>
                                </div>
                                <div className="primary-line-wrap _2">
                                  <div className="line _3"></div>
                                  <div className="line _4"></div>
                                </div>
                                <div className="primary-line-wrap _3">
                                  <div className="line _5"></div>
                                  <div className="line _6"></div>
                                </div>
                                <div className="primary-line-wrap _4">
                                  <div className="line _7"></div>
                                  <div className="line _8"></div>
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                        <div
                          className="btn-apply"
                          style={{ display: isApplied ? "block" : "none" }}
                        >
                          <div className="primary-button-wrapper">
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                setIsApplied(false);
                                setCouponCode("");
                                setCouponMsg("");
                                calculateTotalPrice();
                                toast.info(t("couponUnapplied"));
                                // Optionally recalc total price
                                // calculateTotalPrice();
                              }}
                              data-w-id="3af1c84f-ff74-c014-cb3b-40446b73b1f6"
                              className="primary-button w-inline-block"
                            >
                              <div className="primary-button-border-wrap">
                                <div className="primary-button-wrap">
                                  <div className="primary-button-text">
                                    {t("unApply")}
                                  </div>
                                  <div className="primary-button-hover-text">
                                    {t("unApply")}
                                  </div>
                                  <div className="primary-button-hover-bg"></div>
                                </div>
                              </div>
                              <div className="line-wrap">
                                <div className="primary-line-wrap _1">
                                  <div className="line _1"></div>
                                  <div className="line _2"></div>
                                </div>
                                <div className="primary-line-wrap _2">
                                  <div className="line _3"></div>
                                  <div className="line _4"></div>
                                </div>
                                <div className="primary-line-wrap _3">
                                  <div className="line _5"></div>
                                  <div className="line _6"></div>
                                </div>
                                <div className="primary-line-wrap _4">
                                  <div className="line _7"></div>
                                  <div className="line _8"></div>
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="btn-apply">
                        <div className="primary-button-wrapper">
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              if (isApplied) {
                                toast.warning(t("alreadyApplied"));
                                return;
                              }
                              applyCoupon();
                            }}
                            data-w-id="3af1c84f-ff74-c014-cb3b-40446b73b1f6"
                            className="primary-button w-inline-block"
                          >
                            <div className="primary-button-border-wrap">
                              <div className="primary-button-wrap">
                                <div className="primary-button-text">
                                  {t("apply")}
                                </div>
                                <div className="primary-button-hover-text">
                                  {t("apply")}
                                </div>
                                <div className="primary-button-hover-bg"></div>
                              </div>
                            </div>
                            <div className="line-wrap">
                              <div className="primary-line-wrap _1">
                                <div className="line _1"></div>
                                <div className="line _2"></div>
                              </div>
                              <div className="primary-line-wrap _2">
                                <div className="line _3"></div>
                                <div className="line _4"></div>
                              </div>
                              <div className="primary-line-wrap _3">
                                <div className="line _5"></div>
                                <div className="line _6"></div>
                              </div>
                              <div className="primary-line-wrap _4">
                                <div className="line _7"></div>
                                <div className="line _8"></div>
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                    )}
                  </div>
                  {couponMsg && (
                    <div className="err-message">
                      <small>{couponMsg}</small>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="review-footer">
              <div className="shipping-methods" style={{ display: "none" }}>
                <h2>{t("shippingMethods")}</h2>
                <div className="method">
                  <input
                    type="radio"
                    checked={true}
                    readOnly
                    className="radio"
                  />
                  <label>{t("standardShipping")}</label>
                </div>
              </div>
              <div className="payment-methods ">
                <div className="payment-card">
                  <h2 className="payment-heading">{t("paymentMethods")}</h2>
                  <div className="row-paymt">
                    {merchantData &&
                      merchantData.map((item) => (
                        <div
                          key={item.merchantId}
                          className={`col-md-3 payment-opt ${merchantId === item.merchantId ? "selected" : ""
                            }`}
                          onClick={() => fnMerchant(item.merchantId)}
                        >
                          {/* Replace with your own images/icons for each payment method */}
                          {item.merchantId === 1 && (
                            <Link className="d-flex align-items-center">
                              <BsCashCoin className="white" />
                            </Link>
                          )}
                          {item.merchantId === 2 && (
                            <Link className="d-flex align-items-center">
                              <MdCurrencyBitcoin className="white" />
                            </Link>
                          )}
                          {item.merchantId === 3 && (
                            <div className="payment-img">
                              <Link className="d-flex align-items-center">
                                <FaCreditCard className="white" />
                              </Link>
                            </div>
                          )}
                          {item.merchantId === 4 && (
                            <Link className="d-flex align-items-center">
                              <IconWallet stroke={2} className="white" />
                            </Link>
                          )}
                          {item.merchantId === 5 && (
                            <Link className="d-flex align-items-center">
                              <IconWallet stroke={2} className="white" />
                            </Link>
                          )}
                          {item.merchantId === 6 && (
                            <Link className="d-flex align-items-center">
                              <IconAward stroke={2} className="white" />
                            </Link>
                          )}
                          {item.displayName === 7 && (
                            <Link className="d-flex align-items-center">
                              <FaCreditCard className="white" />
                            </Link>
                          )}
                          {item.displayName === "Credits" && (
                            <Link className="d-flex align-items-center">
                              <FaCreditCard className="white" />
                            </Link>
                          )}
                          <p>{item.displayName}</p>
                        </div>
                      ))}
                  </div>
                </div>

                {showCardInfo && (
                  <div className="w-100 position-relative">
                    <div
                      className="card mb-3 border credit-card shadow-0"
                      style={{ maxWidth: "610px" }}
                    >
                      <div className="card-body">
                        <h2>{t("Cards")}</h2>
                        {cardInfo &&
                          cardInfo.map((card, index) => {
                            return (
                              <div
                                key={index}
                                className="text-start"
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  margin: "0.5rem",
                                }}
                              >
                                <input
                                  type="radio"
                                  name="payment-card"
                                  className="radio"
                                  value={card.externalId}
                                  onChange={() =>
                                    setSelectedCard(card.externalId)
                                  }
                                />
                                <label style={{ margin: "2px" }}>
                                  {card.displayInfo}
                                </label>
                              </div>
                            );
                          })}
                      </div>
                      <div id="add-card-dv content-box">
                        {/* <button
                          className="theme-btn"
                          onClick={() => fnCardForm(true)}
                        >
                          {t("addCard")}
                        </button> */}

                        <div className="primary-button-wrapper">
                          <a
                            href="#"
                            onClick={() => fnCardForm(true)}
                            data-w-id="3af1c84f-ff74-c014-cb3b-40446b73b1f6"
                            className="primary-button w-inline-block"
                          >
                            <div className="primary-button-border-wrap">
                              {/* {isLoading && <Loader />} */}
                              <div className="primary-button-wrap">
                                <div className="primary-button-text">
                                  {t("addCard")}
                                </div>
                                <div className="primary-button-hover-text">
                                  {t("addCard")}
                                </div>
                                <div className="primary-button-hover-bg"></div>
                              </div>
                            </div>
                            <div className="line-wrap">
                              <div className="primary-line-wrap _1">
                                <div className="line _1"></div>
                                <div className="line _2"></div>
                              </div>
                              <div className="primary-line-wrap _2">
                                <div className="line _3"></div>
                                <div className="line _4"></div>
                              </div>
                              <div className="primary-line-wrap _3">
                                <div className="line _5"></div>
                                <div className="line _6"></div>
                              </div>
                              <div className="primary-line-wrap _4">
                                <div className="line _7"></div>
                                <div className="line _8"></div>
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {isCardForm && (
                  <AddCardForm
                    associateId={parseInt(userData?.associateId)}
                    customerDetails={userData}
                    email={userData?.email}
                    fnCardForm={fnCardForm}
                    getPayment={getPayment}
                  />
                )}

                <div className="form-check my-3 mb-0-4 flex">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="recurringSubCheck"
                    checked={isRecurringChecked}
                    onChange={(e) => setIsRecurringChecked(e.target.checked)}
                    onKeyDown={(e) => {
                      checkKeyPress(e, "payment");
                    }}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="recurringSubCheck"
                    style={{ fontSize: "14px", marginBottom: "0" }}
                  >
                    {t("reviewPageCheckBocText")}
                    &nbsp;
                    <a
                      href="mailto:support@joinnoa.io"
                      className="gradient-text"
                    >
                      support@joinnoa.io
                    </a>
                    {t("youCanCancelUntilDayBeforeRenewalDate")}
                  </label>
                </div>

                {/* <div className="form-check my-3 flex">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="agreeCheck"
                    checked={isAgreeChecked}
                    onChange={(e) => setIsAgreeChecked(e.target.checked)}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="agreeCheck"
                    style={{ fontSize: "14px", marginBottom: "0" }}
                  >
                    {t("iAgreeToAllContracts")}.
                  </label>
                </div> */}

                {errorMsg && <small className="text-danger">{errorMsg}</small>}

                <div className="navbar-button-wrapper">
                  <div className="card-footer-button-wrapper">
                    <div className="navbar-button-wrapper">
                      <div className="primary-button-wrapper">
                        <a
                          href="#"
                          className="inner-button w-inline-block"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            fnBack();
                          }}
                        >
                          <div className="primary-button-border-wrap">
                            <div className="inner-button-wrap">
                              <div className="inner-button-text-wrap">
                                <div className="inner-button-text">
                                  {t("back")}
                                </div>
                                <div className="inner-button-hover-text">
                                  {t("back")}
                                </div>
                              </div>
                              {/* <div className="inner-button-star-wrap">
                                <img
                                  loading="lazy"
                                  src="/images/inner-button-star-1.svg"
                                  alt=""
                                  className="inner-button-star _1"
                                />
                                <img
                                  loading="lazy"
                                  src="/images/inner-button-star-2.svg"
                                  alt=""
                                  className="inner-button-star _2"
                                />
                                <img
                                  loading="lazy"
                                  src="/images/inner-button-star-3.svg"
                                  alt=""
                                  className="inner-button-star _3"
                                />
                              </div> */}
                              <div className="inner-button-hover-bg"></div>
                            </div>
                          </div>
                          <div className="line-wrap-inner">
                            <div className="inner-line-wrap _1">
                              <div className="line"></div>
                              <div className="line _2"></div>
                            </div>
                            <div className="inner-line-wrap _2">
                              <div className="line _3"></div>
                              <div className="line _4"></div>
                            </div>
                            <div className="inner-line-wrap _3">
                              <div className="line _5"></div>
                              <div className="line _6"></div>
                            </div>
                            <div className="inner-line-wrap _4">
                              <div className="line _7"></div>
                              <div className="line _8"></div>
                            </div>
                          </div>
                        </a>
                      </div>

                      <div className="menu-button w-nav-button">
                        <div
                          data-is-ix2-target="1"
                          className="hamburger-menu-icon"
                          data-w-id="b58e0106-6be1-80f9-2e9e-29cc3a30b8aa"
                          data-animation-type="lottie"
                          data-src="/images/hamburger-20menu.lottie"
                          data-loop="0"
                          data-direction="1"
                          data-autoplay="0"
                          data-renderer="svg"
                          data-duration="0"
                          data-ix2-initial-state="0"
                        >
                          <span style={{ color: "#ffffff" }}>
                            <img
                              src="/images/Hamburger_icon.png"
                              alt=""
                              style={{ width: "30%" }}
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="navbar-button-wrapper">
                      <div className="primary-button-wrapper">
                        <a
                          href="#"
                          onKeyDown={(e) => {
                            checkKeyPress(e, "payment");
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            if (!isLoading) handleProcessPayment();
                          }}
                          data-w-id="3af1c84f-ff74-c014-cb3b-40446b73b1f6"
                          className="primary-button w-inline-block"
                        >
                          <div className="primary-button-border-wrap">
                            {isLoading && <Loader />}
                            <div className="primary-button-wrap">
                              <div className="primary-button-text">
                                {t("payment")}
                              </div>
                              <div className="primary-button-hover-text">
                                {t("payment")}
                              </div>
                              <div className="primary-button-hover-bg"></div>
                            </div>
                          </div>
                          <div className="line-wrap">
                            <div className="primary-line-wrap _1">
                              <div className="line _1"></div>
                              <div className="line _2"></div>
                            </div>
                            <div className="primary-line-wrap _2">
                              <div className="line _3"></div>
                              <div className="line _4"></div>
                            </div>
                            <div className="primary-line-wrap _3">
                              <div className="line _5"></div>
                              <div className="line _6"></div>
                            </div>
                            <div className="primary-line-wrap _4">
                              <div className="line _7"></div>
                              <div className="line _8"></div>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
